import React from 'react';
import {
  ButtonV2,
  Heading,
  Section,
  Text,
  VerticalSpace,
} from '@arc-ui/components';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <main role="main">
      <Section>
        <div style={{ textAlign: 'center', padding: '2rem 0' }}>
          <Heading level="1" size="xl">
            404 - Page Not Found
          </Heading>
          <VerticalSpace size="24" />
          <Text elementType="p" size="m">
            The page you&apos;re looking for doesn&apos;t exist.
          </Text>
          <VerticalSpace size="32" />
          <ButtonV2
            label="Go to Search"
            buttonStyle="primary"
            onClick={() => navigate(ROUTES.SEARCH)}
          />
        </div>
      </Section>
    </main>
  );
};

export default NotFound;
